export default __webpack_public_path__ + "static/media/fallbackBackgroundImage.bbf2f8ef.png";